import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteTipoDeMercado, getTiposDeMercado, patchTipoDeMercado, postTipoDeMercado,
} from 'api/catalogos/tiposDeMercado';

// eslint-disable-next-line react/prop-types
const TiposDeMercados = ({ permission }) => (
  <PlainCRUD
    title="Giro de mercado"
    permission={permission}
    get={getTiposDeMercado}
    post={postTipoDeMercado}
    patch={patchTipoDeMercado}
    delete={deleteTipoDeMercado}
    withoutState
    fields={[defaultFields.descripcion]}
  />
);

export default TiposDeMercados;
